const getListOfAvailableCurrencies = prices => {
  const availableCurrencies = {
    NOK: false,
    EUR: false,
    USD: false
  };
  const listOfAvailableCurrencies = [];

  prices.map(item => {
    if (parseFloat(item.value) > 0) {
      availableCurrencies[item.currency.currency] = true;
    }
  });

  Object.keys(availableCurrencies).map(key => {
    if (availableCurrencies[key]) {
      listOfAvailableCurrencies.push(key);
    }
  });

  return listOfAvailableCurrencies;
};

export { getListOfAvailableCurrencies };
